import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Send, MessageCircle } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { api } from "../../lib/api";
import { Logo } from "./Seo";

const Col = ({ title, links }) => (
  <div>
    <h4 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-content-muted mb-4">{title}</h4>
    <ul className="space-y-3 text-[13px]">
      {links.map((l) => <li key={l.label}><Link to={l.to} className="text-content-secondary hover:text-content transition-colors">{l.label}</Link></li>)}
    </ul>
  </div>
);

export default function Footer() {
  const { settings, exams } = useSite();
  const [pages, setPages] = useState([]);
  useEffect(() => { api.get("/pages").then((r) => setPages((r.data || []).filter((p) => p.show_in_footer))).catch(() => {}); }, []);
  const wa = (settings.whatsapp || "").replace(/\D/g, "");
  const examLinks = (exams || []).slice(0, 6).map((e) => ({ label: e.name, to: `/${e.slug}` }));
  const social = settings.social || {};
  const companyLinks = [{ label: "About", to: "/about" }, { label: "Contact", to: "/contact" },
    ...pages.map((p) => ({ label: p.title, to: `/p/${p.slug}` }))];
  return (
    <footer className="mt-10 border-t border-line bg-surface/60">
      <div className="container-max container-px py-14">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="text-[13px] text-content-secondary mt-4 max-w-xs leading-relaxed">{settings.tagline || "Realistic exam practice, PYQs and performance analysis for India's competitive exams."}</p>
            <div className="flex gap-2 mt-5">
              {wa && <SocialLink href={`https://wa.me/${wa}`} Icon={MessageCircle} />}
              {social.instagram && <SocialLink href={social.instagram} Icon={Instagram} />}
              {social.youtube && <SocialLink href={social.youtube} Icon={Youtube} />}
              {social.telegram && <SocialLink href={social.telegram} Icon={Send} />}
            </div>
          </div>
          <Col title="Platform" links={[{ label: "Test Series", to: "/pricing" }, { label: "Free Mocks", to: "/free-tests" }, { label: "Blog", to: "/blog" }, { label: "Search", to: "/search" }]} />
          <Col title="Exams" links={examLinks.length ? examLinks : [{ label: "SSC", to: "/ssc" }, { label: "UPSC", to: "/upsc" }, { label: "Banking", to: "/banking" }]} />
          <Col title="Company" links={companyLinks} />
          <Col title="Legal" links={[{ label: "Privacy Policy", to: "/privacy-policy" }, { label: "Terms", to: "/terms-and-conditions" }, { label: "Refund Policy", to: "/refund-policy" }, { label: "Disclaimer", to: "/disclaimer" }]} />
        </div>

        <div className="mt-12 pt-6 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-[13px] text-content-secondary">
            <a href={`mailto:${settings.email}`} className="hover:text-content">{settings.email || "support@agni.shiksha"}</a>
            <span className="mx-2 text-content-muted">·</span>
            <a href={`tel:${settings.phone || settings.whatsapp}`} className="hover:text-content">{settings.phone || settings.whatsapp}</a>
          </div>
          <p className="text-xs text-content-muted">© {new Date().getFullYear()} {settings.brand_name || "Agni Shiksha"}. Not affiliated with any government recruitment body.</p>
        </div>
      </div>
    </footer>
  );
}

const SocialLink = ({ href, Icon }) => (
  <a href={href} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-lg bg-white/5 border border-line flex items-center justify-center hover:border-white/20 hover:text-content text-content-secondary transition-colors">
    <Icon className="w-4 h-4" />
  </a>
);
